/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { Typography, Grid, Box, IconButton } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from 'utils/makeStylesAdapter';
import { toast } from 'react-toastify';
import { HeaderModal, ButtonConsensus, InputConsensus } from 'components';
import { colors } from 'utils/colorsSteps';
import { MenuItem, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import investigatedCertificateService from 'services/investigated-certificates/investigatedCertificateService';
import { Badge } from '@mui/material';
import ModalAddCertificates, { ModalAddJustification } from '../ModalAddCertificates';
import SubjectIcon from '@mui/icons-material/Subject';
import ModalFinalizationConfirm from '../ModalFinalizationConfirm';
import HistoryIcon from '@mui/icons-material/History';
import CancelIcon from '@mui/icons-material/Cancel';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import ArticleIcon from '@mui/icons-material/Article';
import ModalGenerateAndMonitorNoticePublic from 'components/ModalGenerateAndMonitorNoticePublic';
import {
  CERTIFICATE_TYPES,
  CERTIFICATE_TYPES_ARRAY,
} from 'constants/investigated-certificate-types';
import ModalIntimationAutomatic from '../ModalIntimationAutomatic';
import ModalCancel from '../ModalCancel';
import intimationService from 'services/intimation/intimationService';

const useStyles = makeStyles(() => ({
  root: {
    background: '#fff',
    borderRadius: 10,
    padding: 16,
  },
  dropzone: {
    height: '100%',
    width: '100%',
    border: '1px dashed #292929',
    display: 'flex',
    justifyContent: 'center',
    borderRadius: 10,
    cursor: 'pointer',
  },
  inputMaterial: {
    width: '100%',
  },
}));

const TableHandleCertificates = props => {
  const {
    open,
    onClose,
    inquiry,
    setWasCertificationFinalized,
    intimations,
    getIntimations,
    onRefresh,
  } = props;
  const classes = useStyles();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [certificatesFiles, setCertificatesFiles] = useState([]);
  const [certificates, setCertificates] = useState([]);
  const [openAddCertificates, setOpenAddCertificates] = useState(false);
  const [openModalJustification, setOpenModalJustification] = useState(false);
  const [openModalFinalizationConfirm, setOpenModalFinalizationConfirm] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedVictim, setSelectedVictim] = useState(null);
  const [selectedVictimCertificate, setSelectedVictimCertificate] = useState(null);
  const [openIntimationAutomaticModal, setOpenIntimationAutomaticModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const [openModalCancelAutomatic, setOpenModalCancelAutomatic] = useState(false);
  const [selectedIntimation, setSelectedIntimation] = useState(null);
  const [loadingCancel, setLoadingCancel] = useState(false);
  const [
    openModalGenerateAndMonitorNoticePublic,
    setOpenModalGenerateAndMonitorNoticePublic,
  ] = useState(false);

  useEffect(() => {
    if (!openAddCertificates && !openModalJustification && !openIntimationAutomaticModal) {
      getCertificates();
    }
  }, []);

  const getCertificates = async () => {
    setLoading(true);
    try {
      const response = await investigatedCertificateService.getCertificateWithJustificationService(
        inquiry.id,
      );

      const groupedFiles = {
        Juízo: [],
        Investigado: [],
        Vítima: [],
        Delegado: [],
      };

      const certificates = [];

      response.data.forEach(certificate => {
        groupedFiles[certificate.type].push(...certificate.files);
        certificates.push(certificate);
      });

      setCertificates(certificates);
      setCertificatesFiles(groupedFiles);

      return groupedFiles;
    } catch (error) {
      toast.error('Erro ao buscar certidões');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenAddModal = (type, victim = null, victimCertificate = null) => {
    setSelectedType(type);
    setSelectedVictim(victim);
    setSelectedVictimCertificate(victimCertificate);
    setOpenAddCertificates(true);
  };

  const handleOpenModalJustification = (type, victim = null, victimCertificate = null) => {
    setSelectedType(type);
    setSelectedVictim(victim);
    setSelectedVictimCertificate(victimCertificate);
    setOpenModalJustification(true);
  };

  const handleOpenIntimationAutomaticModal = (type, victim = null, victimCertificate = null) => {
    setSelectedType(type);
    setSelectedVictim(victim);
    setSelectedVictimCertificate(victimCertificate);
    setOpenIntimationAutomaticModal(true);
  };

  const handleCloseIntimationAutomaticModal = () => {
    setOpenIntimationAutomaticModal(false);
  };

  const handleConfirmFinalization = () => {
    setOpenModalFinalizationConfirm(false);
    finalizeCertificates();
  };

  const handleConfirmClose = () => {
    setOpenModalFinalizationConfirm(false);
  };

  const finalizeCertificates = () => {
    const isValidCertificate = type => {
      if (type === CERTIFICATE_TYPES.VITIMA) return true;
      const hasFiles = certificatesFiles[type]?.length > 0;
      const hasJustification = certificates.some(cert => cert.type === type && cert.justification);
      return hasFiles || hasJustification;
    };

    const victims = inquiry?.inquiry?.victims || [];
    const allVictimsValid = victims.every(victim => {
      const victimCertificate = certificates.find(
        cert => cert.type === CERTIFICATE_TYPES.VITIMA && cert.victimId === victim.id,
      );
      const hasFiles = victimCertificate?.files?.length > 0;
      const hasJustification = !!victimCertificate?.justification;
      return hasFiles || hasJustification;
    });

    const allTypesValid = CERTIFICATE_TYPES_ARRAY.every(type => isValidCertificate(type));

    if (!allTypesValid) {
      toast.error('É necessário adicionar ao menos uma certidão ou justificativa de cada tipo');
      return;
    }
    if (!allVictimsValid) {
      toast.error('É necessário adicionar ao menos uma certidão ou justificativa para cada vítima');
      return;
    }

    toast.success('Certidões salvas com sucesso');
    setWasCertificationFinalized(true);
    onClose();
  };

  const hasSuccessfulIntimation = (type, victim = null) => {
    if (type !== CERTIFICATE_TYPES.VITIMA) {
      return intimations?.some(
        intimation => intimation.recipient === type && intimation.status === 'SUCCESS',
      );
    }

    if (!victim) return false;
    return intimations?.some(
      intimation =>
        intimation.recipient === CERTIFICATE_TYPES.VITIMA &&
        intimation.victim?.id === victim.id &&
        intimation.status === 'SUCCESS',
    );
  };

  const hasAwaitingIntimation = (type, victim = null) => {
    if (type !== CERTIFICATE_TYPES.VITIMA) {
      return intimations?.some(
        intimation => intimation.recipient === type && intimation.status === 'AWAITING_RESPONSE',
      );
    }

    if (!victim) return false;
    return intimations?.some(
      intimation =>
        intimation.recipient === CERTIFICATE_TYPES.VITIMA &&
        intimation.victim?.id === victim.id &&
        intimation.status === 'AWAITING_RESPONSE',
    );
  };

  const statusToShowNoticeButton = [
    'AWAITING_NOTICE', 
    'MANUAL_PUBLISHED_NOTICE', 
    'PUBLISHED_NOTICE'
  ];

  const hasOnlyNoticeAttemptRemaining = (type, victim = null) => {
    let targetIntimation;
    if (type !== CERTIFICATE_TYPES.VITIMA) {
      targetIntimation = intimations?.find(intimation => intimation.recipient === type);
    } else if (victim) {
      targetIntimation = intimations?.find(
        intimation =>
          intimation.recipient === CERTIFICATE_TYPES.VITIMA && intimation.victim?.id === victim.id,
      );
    }

    if (!targetIntimation) {
      return false;
    }

    return statusToShowNoticeButton.includes(targetIntimation.noticeStatus);
  };

  const cancelAutomaticIntimation = () => {
    if (loadingCancel) return;
    setLoadingCancel(true);
    intimationService
      .cancelIntimation(selectedIntimation?.id)
      .then(() => {
        toast.success('Intimação automática cancelada com sucesso!');
        getCertificates();
        getIntimations();
      })
      .finally(() => {
        setLoadingCancel(false);
        setOpenModalCancelAutomatic(false);
      });
  };

  return (
    <div className={clsx(classes.root)}>
      <form>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <Typography variant="h5">
              Total de arquivos: {Object.values(certificatesFiles).flat().length}
            </Typography>
          </Grid>
        </Grid>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">Tipo</TableCell>
              <TableCell align="center">Número de Arquivos</TableCell>
              <TableCell align="center">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(certificatesFiles)
              .filter(([type]) => type !== CERTIFICATE_TYPES.VITIMA)
              .map(([type, files]) => (
                <TableRow key={type}>
                  <TableCell align="center">{type}</TableCell>
                  <TableCell align="center">{files.length} arquivo(s)</TableCell>
                  <TableCell align="center">
                    <Tooltip arrow placement="top" title="Adicionar justificativa">
                      <span>
                        <IconButton
                          onClick={() => handleOpenModalJustification(type)}
                          disabled={type === CERTIFICATE_TYPES.JUIZO}
                        >
                          {type !== CERTIFICATE_TYPES.JUIZO && (
                            <Badge
                              badgeContent={
                                certificates.some(cert => cert.type === type && cert.justification)
                                  ? 1
                                  : 0
                              }
                              color="secondary"
                              overlap="circular"
                              showZero
                            >
                              <SubjectIcon fontSize="small" />
                            </Badge>
                          )}
                          {type === CERTIFICATE_TYPES.JUIZO && <SubjectIcon fontSize="small" />}
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip
                      arrow
                      placement="top"
                      title={
                        type === CERTIFICATE_TYPES.JUIZO
                          ? 'Visualizar Arquivos'
                          : 'Adicionar Certidão'
                      }
                    >
                      <IconButton color="primary" onClick={() => handleOpenAddModal(type)}>
                        <AttachFileIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip arrow placement="top" title="Realizar intimação automática">
                      <span>
                        <IconButton
                          color="secondary"
                          onClick={() => {
                            handleOpenIntimationAutomaticModal(type);
                          }}
                          disabled={
                            type === CERTIFICATE_TYPES.JUIZO ||
                            hasAwaitingIntimation(type) ||
                            hasSuccessfulIntimation(type)
                          }
                        >
                          <AutoModeIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    {hasAwaitingIntimation(type) &&
                      type !== CERTIFICATE_TYPES.DELEGADO &&
                      type !== CERTIFICATE_TYPES.INVESTIGADO && (
                        <Tooltip arrow placement="top" title="Cancelar intimação automática">
                          <span>
                            <IconButton
                              color="secondary"
                              onClick={() => {
                                setSelectedIntimation(
                                  intimations.find(intimation => intimation.recipient === type),
                                );
                                setOpenModalCancelAutomatic(true);
                              }}
                              disabled={type === CERTIFICATE_TYPES.JUIZO}
                            >
                              <CancelIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      )}
                    {hasOnlyNoticeAttemptRemaining(type) && (
                      <Tooltip arrow placement="top" title="Gerar/Baixar edital">
                        <span>
                          <IconButton
                            color="primary"
                            onClick={() => {
                              setSelectedIntimation(
                                intimations.find(intimation => intimation.recipient === type),
                              );
                              setOpenModalGenerateAndMonitorNoticePublic(true);
                            }}
                          >
                            <ArticleIcon fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            {(!inquiry?.inquiry?.victims || inquiry?.inquiry?.victims.length === 0) && (
              <TableRow key="vitima-sem-victims">
                <TableCell align="center">Vítima</TableCell>
                <TableCell align="center">0 arquivo(s)</TableCell>
                <TableCell align="center">
                  <Tooltip title="Não há vítimas para este inquérito" arrow placement="top">
                    <span>
                      <IconButton disabled>
                        <Badge badgeContent={0} color="secondary" overlap="circular" showZero>
                          <SubjectIcon fontSize="small" />
                        </Badge>
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title="Não há vítimas para este inquérito" arrow placement="top">
                    <span>
                      <IconButton color="primary" disabled>
                        <AttachFileIcon fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title="Não há vítimas para este inquérito" arrow placement="top">
                    <span>
                      <IconButton color="secondary" disabled>
                        <AutoModeIcon fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>
                </TableCell>
              </TableRow>
            )}
            {inquiry?.inquiry?.victims?.map(victim => {
              const victimCertificate = certificates.find(
                cert => cert.type === CERTIFICATE_TYPES.VITIMA && cert.victimId === victim.id,
              );
              const victimFiles = victimCertificate?.files || [];
              const hasJustification = !!victimCertificate?.justification;
              const successIntimation = hasSuccessfulIntimation(CERTIFICATE_TYPES.VITIMA, victim);
              const awaitingIntimation = hasAwaitingIntimation(CERTIFICATE_TYPES.VITIMA, victim);

              return (
                <TableRow key={`vitima-${victim.id}`}>
                  <TableCell align="center">Vítima: {victim.name}</TableCell>
                  <TableCell align="center">{victimFiles.length} arquivo(s)</TableCell>
                  <TableCell align="center">
                    <Tooltip arrow placement="top" title="Adicionar justificativa">
                      <span>
                        <IconButton
                          onClick={() =>
                            handleOpenModalJustification(
                              CERTIFICATE_TYPES.VITIMA,
                              victim,
                              victimCertificate,
                            )
                          }
                        >
                          <Badge
                            badgeContent={hasJustification ? 1 : 0}
                            color="secondary"
                            overlap="circular"
                            showZero
                          >
                            <SubjectIcon fontSize="small" />
                          </Badge>
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip arrow placement="top" title="Adicionar Certidão">
                      <IconButton
                        color="primary"
                        onClick={() =>
                          handleOpenAddModal(CERTIFICATE_TYPES.VITIMA, victim, victimCertificate)
                        }
                      >
                        <AttachFileIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip arrow placement="top" title="Realizar intimação automática">
                      <span>
                        <IconButton
                          color="secondary"
                          onClick={() =>
                            handleOpenIntimationAutomaticModal(
                              CERTIFICATE_TYPES.VITIMA,
                              victim,
                              victimCertificate,
                            )
                          }
                          disabled={successIntimation || awaitingIntimation}
                        >
                          <AutoModeIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    {awaitingIntimation && (
                      <Tooltip arrow placement="top" title="Cancelar intimação automática">
                        <span>
                          <IconButton
                            color="secondary"
                            onClick={() => {
                              setSelectedIntimation(
                                intimations.find(
                                  intimation =>
                                    intimation.recipient === CERTIFICATE_TYPES.VITIMA &&
                                    intimation.victim?.id === victim.id,
                                ),
                              );
                              setOpenModalCancelAutomatic(true);
                            }}
                          >
                            <CancelIcon fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                    )}
                    {hasOnlyNoticeAttemptRemaining(CERTIFICATE_TYPES.VITIMA, victim) && (
                      <Tooltip arrow placement="top" title="Gerar/Baixar edital">
                        <span>
                          <IconButton
                            color="primary"
                            onClick={() => {
                              setSelectedIntimation(
                                intimations.find(
                                  intimation =>
                                    intimation.recipient === CERTIFICATE_TYPES.VITIMA &&
                                    intimation.victim?.id === victim.id,
                                ),
                              );
                              setOpenModalGenerateAndMonitorNoticePublic(true);
                            }}
                          >
                            <ArticleIcon fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <Grid container style={{ marginTop: 20, marginBottom: 20 }}>
          <Grid
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <ButtonConsensus
              title="Finalizar"
              onClick={() => setOpenModalFinalizationConfirm(true)}
              disabled={loading}
            />
          </Grid>
        </Grid>
      </form>
      <ModalAddCertificates
        open={openAddCertificates}
        onClose={() => setOpenAddCertificates(false)}
        inquiry={inquiry}
        existingCertificatesFiles={
          selectedType === CERTIFICATE_TYPES.VITIMA
            ? selectedVictimCertificate?.files || []
            : certificatesFiles[selectedType]
        }
        intimations={
          selectedType === CERTIFICATE_TYPES.VITIMA && selectedVictim
            ? intimations.filter(
                intimation =>
                  intimation.recipient === CERTIFICATE_TYPES.VITIMA &&
                  intimation.victim?.id === selectedVictim.id,
              )
            : intimations.filter(intimation => intimation.recipient === selectedType)
        }
        selectedType={selectedType}
        victim={selectedVictim}
        getCertificates={getCertificates}
      />
      <ModalAddJustification
        open={openModalJustification}
        onClose={() => setOpenModalJustification(false)}
        inquiry={inquiry}
        existingCertificates={
          selectedType === CERTIFICATE_TYPES.VITIMA
            ? selectedVictimCertificate
              ? [selectedVictimCertificate]
              : []
            : certificates
        }
        selectedType={selectedType}
        victim={selectedVictim}
        getCertificates={getCertificates}
      />
      <ModalIntimationAutomatic
        open={openIntimationAutomaticModal}
        onClose={handleCloseIntimationAutomaticModal}
        inquiry={inquiry}
        loading={loading}
        setLoading={setLoading}
        recipient={selectedType}
        intimationCertificate={
          selectedType === CERTIFICATE_TYPES.VITIMA
            ? selectedVictimCertificate || undefined
            : certificates.filter(cert => cert.type === selectedType)[0]
        }
        selectedType={selectedType}
        victim={selectedVictim}
        getCertificates={getCertificates}
        getIntimations={getIntimations}
      />
      <ModalFinalizationConfirm
        open={openModalFinalizationConfirm}
        onClose={handleConfirmClose}
        onConfirm={handleConfirmFinalization}
        title="Confirmar Finalização"
        message="Você tem certeza de que deseja finalizar?"
      />
      <ModalCancel
        open={openModalCancelAutomatic}
        onClose={() => setOpenModalCancelAutomatic(false)}
        cancellIntimation={cancelAutomaticIntimation}
      />
      <ModalGenerateAndMonitorNoticePublic
        open={openModalGenerateAndMonitorNoticePublic}
        onClose={() => setOpenModalGenerateAndMonitorNoticePublic(false)}
        inquiry={inquiry}
        intimation={selectedIntimation}
        onRefresh={onRefresh}
        getIntimations={getIntimations}
      />
    </div>
  );
};
export default TableHandleCertificates;
